export type CrmStage = 'LEAD' | 'EM_CONVERSA' | 'PROPOSTA' | 'FECHADO';

export type CrmActivityTipo =
  | 'NOTA'
  | 'REUNIAO'
  | 'VALOR_INFORMADO'
  | 'PROXIMO_PASSO'
  | 'VOICE_TASK'
  | 'MATCH_ACEITO'
  | 'STAGE_CHANGE'
  | 'LIGACAO'
  | 'EMAIL'
  | 'OUTRO';

export const CRM_ACTIVITY_LABELS: Record<CrmActivityTipo, string> = {
  NOTA: 'Nota',
  REUNIAO: 'Reunião',
  VALOR_INFORMADO: 'Valor informado',
  PROXIMO_PASSO: 'Próximo passo',
  VOICE_TASK: 'Voice task',
  MATCH_ACEITO: 'Match aceito',
  STAGE_CHANGE: 'Mudança de etapa',
  LIGACAO: 'Ligação',
  EMAIL: 'Email',
  OUTRO: 'Outro',
};

export type CrmActivity = {
  id: string;
  tipo: CrmActivityTipo;
  descricao: string;
  createdAt: string;
};

export type CrmEntry = {
  id: string;
  matchId: string;
  participanteId: string;
  participanteNome: string;
  participanteFotoUrl?: string | null;
  stage: CrmStage;
  valorPotencial?: number | null;
  atividades: CrmActivity[];
  createdAt: string;
  updatedAt: string;
};
